import { render, staticRenderFns } from "./ExperineciaComponent.vue?vue&type=template&id=4ec03b99&"
import script from "./ExperineciaComponent.vue?vue&type=script&lang=js&"
export * from "./ExperineciaComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExperineciaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports